export const isDefinedAndNotNull = <T>(input: T): input is NonNullable<T> => {
  return input !== undefined && input !== null
}
